import { useBrandKitStore } from "../stores/brand-kit-store";

export const useBrandKits = () => {
	const brandKit = useBrandKitStore((state) => state.brandKit);
	const viewBrandKit = useBrandKitStore((state) => state.view);
	const updateBrandKit = useBrandKitStore((state) => state.update);
	const updateIconWithLabel = useBrandKitStore((state) => state.updateIconWithLabel);
	const deleteIconWithLabel = useBrandKitStore((state) => state.deleteIconWithLabel);
	const updateLogoIconOnly = useBrandKitStore((state) => state.updateLogoIconOnly);
	const deleteLogoIconOnly = useBrandKitStore((state) => state.deleteLogoIconOnly);
	const updateLogoLabelOnly = useBrandKitStore((state) => state.updateLogoLabelOnly);
	const deleteLogoLabelOnly = useBrandKitStore((state) => state.deleteLogoLabelOnly);
	const updateFavicon = useBrandKitStore((state) => state.updateFavicon);
	const deleteFavicon = useBrandKitStore((state) => state.deleteFavicon);
	const updateLogoInvertedIconOnly = useBrandKitStore((state) => state.updateLogoInvertedIconOnly);
	const deleteLogoInvertedIconOnly = useBrandKitStore((state) => state.deleteLogoInvertedIconOnly);
	const updateLogoInvertedIconWithLabel = useBrandKitStore((state) => state.updateLogoInvertedIconWithLabel);
	const deleteLogoInvertedIconWithLabel = useBrandKitStore((state) => state.deleteLogoInvertedIconWithLabel);
	const updateLogoInvertedLabelOnly = useBrandKitStore((state) => state.updateLogoInvertedLabelOnly);
	const deleteLogoInvertedLabelOnly = useBrandKitStore((state) => state.deleteLogoInvertedLabelOnly);

	return {
		brandKit,
		viewBrandKit,
		updateBrandKit,
		updateIconWithLabel,
		deleteIconWithLabel,
		updateLogoIconOnly,
		deleteLogoIconOnly,
		updateLogoLabelOnly,
		deleteLogoLabelOnly,
		updateFavicon,
		deleteFavicon,
		updateLogoInvertedIconOnly,
		deleteLogoInvertedIconOnly,
		updateLogoInvertedIconWithLabel,
		deleteLogoInvertedIconWithLabel,
		updateLogoInvertedLabelOnly,
		deleteLogoInvertedLabelOnly,
	};
};
